import { TerritorySettingsSubpage } from '../../components/TerritorySettings/constants';

export const getTerritorySettingsPageUrl = (
  territorySlug: string,
  subpage: TerritorySettingsSubpage | string,
): string => `/t/${territorySlug}/settings/${subpage}`;
